module.exports = __webpack_public_path__ + "img/P63-en.73ca90cd.png";